import React, { useContext, useEffect, useState } from "react";
import ScreenLoader from "../../HtmlElements/ScreenLoader";
import { Link } from "react-router-dom";
import ComingSoon from "../../Frontend/AccountDetails/Nudges/comingSoonComp";
import { useUser } from "../../../context/UserContext";
import api from "../../../services/api";
import { fetchClientsAccountsList } from "../../../services/accIqService";
import GenericOverviewSideCard from "../../Frontend/genericComponents/GenericOverviewSideCard";
import AddUserSC from "./AddUserSC";
import { Button } from "react-bootstrap";
import { numberWithCommas } from "../../../services/commonService";
import GenericTableSkeleton from "../../Frontend/skeletons/tableSkeleton/genericTableSkeleton";
import { AccountListContext } from "../../../context/AccountListContext";
import TagOverflowHandler from "../../Frontend/uiUtils/TagOverflowHandler";
import ResizableDivForTag from "../../Frontend/uiUtils/resizeobs/ResizableDivForTag";

export default function UserList() {
  const { user } = useUser();

  const [searchTerm, setSearchTerm] = useState("");
  const { updateMyReportContext, loading, allAccounts } =
      useContext(AccountListContext);

  const [show_loading, setLoader] = useState(true);
  const [user_list, setUserList] = useState([]);
  const [account_list, setAccountList] = useState([]);
  const [assignedAccountsMap, setAssignedAccountsMap] = useState({});
  const [showAddUserSC, setShowAddUserSC] = useState(false);
  const [edit_user_id, setEditUserId] = useState(false);
  const [currentRecords, setCurrentRecords] = useState([]); // State for current page records
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState("user_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedRecords, setSortedRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [totalPages, setTotalPages] = useState(0);;

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
      setCurrentPage(1);
  }, [searchTerm]);

  const fetchAccountList = async () => {
      // const filterData = {'is_active': 1, is_deleted: 0, limit: 1000}
      // const response_1 = await api.get('/accounts/get_client_admin_account_list', { "params": filterData })
      // let accounts_1 = response_1?.data?.result?.list ? [...response_1.data.result.list] : [] ;
      // let accountsIdsWiseMap = {};
      // for (let account of accounts_1) {
      //   account.account_name =
      //   accountsIdsWiseMap[account.id] = account;
      // }
      // console.log("accountsIdsWiseMap ", accountsIdsWiseMap)

      const response = await fetchClientsAccountsList("", user?.company_name);
      let accounts = response?.accounts ? [...response?.accounts] : [];
      const finalAccountList = [];
      for (let account of accounts) {
        finalAccountList.push({
          account_code: account?.company_code,
          account_name:
            account?.company_details?.[0]?.display_name || account?.name,
        });
      }
      setAccountList(finalAccountList);
      return finalAccountList;
    };

  const fetchUserList = async () => {
      const filterData = {
        is_active: 1,
        is_deleted: 0,
        company_id: user?.company_id,
        limit: 1000,
      };
      const response = await api.get("/users/get_users_list", {
        params: filterData,
      });
      let users = response?.data?.result?.list
        ? [...response.data.result.list]
        : [];

      setUserList(users);
      return users;
    };

  useEffect(() => {
  const fetchAllData = async () => {
    setLoader(true);
    if (user.id) {
      const [userData, accountData] = await Promise.all([
        fetchUserList(),
        fetchAccountList(),
      ]);

      const newAssignedMap = {};
      userData.forEach((user) => {
        if(accountData.length){
          newAssignedMap[user.id] = accountData?.filter((account) =>
            user?.assigned_accounts?.includes(account?.account_code)
          );
        }
      });
      setAssignedAccountsMap(newAssignedMap);
    }
    setLoader(false);
  };

  fetchAllData();
}, [user.id, showAddUserSC]);

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setCurrentPage(1);
    setSortField(field);
    setSortOrder(order);
  };

  const getSortedRecords = () => {
    const sortedRecords = user_list.sort((a, b) => {
      let is_numeric = false;
      let dataSortField = "user_name";

      if (sortField === "user_name") {
        dataSortField = "user_name";
        a.user_name = a.firstname + " "+a.lastname
        b.user_name = b.firstname + " "+b.lastname
        is_numeric = true;
      } else if (sortField === "email") {
        dataSortField = "email";
      } else if (sortField === "number_of_accounts") {
        dataSortField = "number_of_accounts";
        is_numeric = true;
        a.number_of_accounts = a?.assigned_accounts?.length || 0;
        b.number_of_accounts = b?.assigned_accounts?.length || 0;
      }

      // Helper function to access nested properties by string path
      const getNestedValue = (obj, path) =>
        path.split(".").reduce((acc, part) => acc && acc[part], obj);

      const valueA = getNestedValue(a, dataSortField);
      const valueB = getNestedValue(b, dataSortField);

      // Handling NaN or undefined values
      const numA = is_numeric ? parseFloat(valueA) : valueA;
      const numB = is_numeric ? parseFloat(valueB) : valueB;

      // Handle NaN or undefined by pushing to the bottom
      if (valueA === undefined || valueA === null || valueA === "")
        return sortOrder === "asc" ? -1 : 1;
      if (valueB === undefined || valueB === null || valueB === "")
        return sortOrder === "asc" ? 1 : -1;

      // Normal comparison
      if (typeof valueA === "string" && typeof valueB === "string") {
        return sortOrder === "asc"
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
        if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
      }


      return 0;
    });

    return sortedRecords;
  };

  useEffect(() => {
    if (user_list.length) {
      const sortedRecords = getSortedRecords();
      setSortedRecords(sortedRecords);
    } else {
      setSortedRecords([]);
    }
  }, [user_list, sortField, sortOrder]);

  useEffect(() => {
    const filteredRecords = sortedRecords.filter((record) => {
      const search = searchTerm.toLowerCase();

      const firstName = record.firstname?.toLowerCase() || "";
      const lastName = record.lastname?.toLowerCase() || "";
      const fullName = `${firstName} ${lastName}`;
      const email = record.email?.toLowerCase() || "";

      return (
        firstName.includes(search) ||
        lastName.includes(search) ||
        fullName.includes(search) ||
        email.includes(search)
      );
    });

    const indexOfLastRecord = currentPage * perPage;
    const indexOfFirstRecord = indexOfLastRecord - perPage;
    // const current_records = sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord);
    const current_records = filteredRecords.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );

    setCurrentRecords(current_records); // Set current page records
    setTotalPages(Math.ceil(filteredRecords.length / perPage));
    setFilteredRecords(filteredRecords);
  }, [currentPage, sortedRecords, sortField, sortOrder, searchTerm]);

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const modalAddUser = (user_id = "") => {
    setShowAddUserSC(true);
    setEditUserId(user_id);
  };

  const getListTags = (my_data,idx) => {
      const tabConfig =  my_data.map((item)=>( {
          key:idx,
          label:item['account_name']
        })
      )
      return <ResizableDivForTag handleSideCard={() => {}} items={tabConfig} rowData={{}} />

      // return <TagOverflowHandler  handleSideCard={()=>null} tabConfig={tabConfig} rowData={{}} showMinimumCount={2} />
  }

  return (
    <div className="col-md-12 mt-2">
      {show_loading ? (
        <GenericTableSkeleton colCount={4} rowCount={10} />
      ) : (
        <>
          <div className="row">
            <div className="col-md-3">
              {/* <h4 className="blue add_user_heading">User List</h4> */}
              <h5 class="target_head mb-0">User List</h5>
            </div>
            <div className="col-md-9 align-right pb-3">
              <div className="d-flex pull-right">
                <input
                  type="text"
                  className="form-control mr-3"
                  placeholder="Search..."
                  style={{
                    width: "350px",
                    height: "32px",
                    padding: "8px 4px 8px 12px",
                    border: "0.5px solid #42464847",
                    backgroundColor: "#FFFFFF",
                    fontSize: "12.5px",
                    lineHeight: "15.63px",
                    fontWeight: "500",
                    color: "#9595A1",
                  }}
                  value={searchTerm}
                  onChange={(e) => handleSearch(e)}
                />

              <Link
                className="profile_buttons btn font12"
                to="#"
                onClick={() => modalAddUser("")}
              >
                <i className="fa fa-plus" aria-hidden="true"></i> Add User
              </Link>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="accounts_table_block ">
                <div className="table-responsive_1">
                  <table className="accounts_table custom-resizable-table">
                    <thead className="accounts_thead">
                      <tr className="tr_growth">
                        <th className="accounts_th cursorP" width="250" onClick={() => handleSort("user_name")}>
                          User Name
                          {sortField === "user_name" &&
                            (sortOrder === "asc" ? "▲" : "▼")}
                        </th>
                        <th className="accounts_th cursorP" width="250" style={{
                          maxWidth: '300px'
                        }} onClick={() => handleSort("email")} >
                          Email 
                          {sortField === "email" &&
                            (sortOrder === "asc" ? "▲" : "▼")}

                        </th>
                        <th className="accounts_th cursorP" width="400" style={{
                            maxWidth: '350px'
                          }}
                          onClick={() => handleSort('number_of_accounts')}
                        >
                          User Accounts

                          {sortField === "number_of_accounts" &&
                            (sortOrder === "asc" ? "▲" : "▼")}

                        </th>
                        <th
                          className="accounts_th cursorP text_right"
                          width="150"
                        >
                          {" "}
                          Action{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="accounts_tbody">
                      {currentRecords?.map((user, index) => {
                        return (
                          <tr>
                            <td className="accounts_td">
                              {user?.firstname} {user?.lastname}
                            </td>
                            <td className="accounts_td">{user?.email}</td>
                            <td className="accounts_td" style={{minWidth: '250px', maxWidth: '300px'}}>
                              <div className="gtr-cell-content-container">
                                     

                                {getListTags(assignedAccountsMap[user?.id] || [])}

                                {/* {(assignedAccountsMap[user?.id] || []).map(
                                  (account, idx) => (
                                    <span
                                      key={account.id}
                                      className="badge bg-secondary mt-1 mr-1 py-1 font12"
                                    >
                                      {account.account_name}
                                    </span>
                                  )
                                )} */}
                              </div>
                            </td>
                            <td className="accounts_td">
                              <Button
                                type="button"
                                className="profile_buttons btn-sm pull-right font12"
                                onClick={() => {
                                  modalAddUser(user.id);
                                }}
                              >
                                Edit User
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <nav className="table_pagination_custom">
                  {user_list.length > perPage && (
                    <ul className="showing-per-page-info pl-0 ml-0 font13">
                      <li className="page-item">
                        <span className="showing">Showing </span>{" "}
                        {user_list.length > 0
                          ? (currentPage - 1) * perPage + 1
                          : 0}
                        -{Math.min(currentPage * perPage, filteredRecords.length)} of{" "}
                        {numberWithCommas(filteredRecords.length)}
                      </li>
                    </ul>
                  )}

                  {user_list.length > perPage && (
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button onClick={handleFirstPage} className="page-link">
                          First
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button onClick={handlePrevPage} className="page-link">
                          <i
                            className="fa fa-angle-left"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </li>
                      {getPageNumbers().map((pageNumber) => (
                        <li
                          key={pageNumber}
                          className={`page-item ${
                            pageNumber === currentPage ? "active" : ""
                          }`}
                        >
                          <button
                            onClick={() => handlePageChange(pageNumber)}
                            className="page-link"
                          >
                            {pageNumber}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button onClick={handleNextPage} className="page-link">
                          <i
                            className="fa fa-angle-right"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button onClick={handleLastPage} className="page-link">
                          Last
                        </button>
                      </li>
                    </ul>
                  )}
                </nav>
              </div>
            </div>
          </div>
        </>
      )}

      <GenericOverviewSideCard
        showMoreModal={showAddUserSC}
        setShowMoreModal={setShowAddUserSC}
        titleForSideCard={null}
        comp={
          <AddUserSC
            onBack={() => setShowAddUserSC(false)}
            edit_user_id={edit_user_id}
            account_list={account_list}
          />
        }
        minWidthForDrawer={"50%"}
      />
    </div>
  );
}
